import { connect } from 'react-redux';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import ResultsFiltersHeader from './ResultsFiltersHeader';
import { limitTo, exclude } from './ResultsFiltersHeaderActions';
import { disableButtons } from './ResultsFiltersHeaderSelectors';

function mapStateToProps(state) {
  return {
    databaseId: databaseIdSelector(state),
    disableButtons: disableButtons(state),
  };
}

const mapDispatchToProps = {
  limitTo,
  exclude,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsFiltersHeader);
